"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const Comments_v2_1 = tslib_1.__importDefault(require("./Comments_v2"));
const Modal_1 = tslib_1.__importDefault(require("../modal/Modal"));
const CommentModal = ({ setModalOpen, authUserId, itemId, getEndpoint, addEndpoint }) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, { title: translate('comment(s)', 'კომენტარ(ებ)ი'), onHide: () => setModalOpen(null), body: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(Comments_v2_1.default, { authUserId: authUserId, itemId: itemId, getEndpoint: getEndpoint, addEndpoint: addEndpoint }) }) }));
};
exports.default = CommentModal;
